<template>
  <div class="from-dialog">
    <van-popup
      closeable
      @close="closeDialog"
      v-model="show"
      :style="{ width: '90%', borderRadius: '5px' }"
    >
      <div class="popup">
        <div class="title">立即体验</div>
        <div class="formData">
          <van-form ref="formRules" @submit="submit">
            <van-field
              v-model="formData.interestProduct"
              :rules="formRules.interestProduct"
              required
              clearable
              label="您感兴趣的产品"
              :border="false"
              placeholder="您感兴趣的产品"
            />
            <van-popover
              v-model="showPopover"
              get-container="#businessInfo"
              class="companyInformation"
              :close-on-click-outside="true"
              :close-on-click-action="true"
            >
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad(false)"
              >
                <div class="list">
                  <div
                    v-for="(item, index) in list"
                    :key="item.name + index"
                    class="list-item"
                    @click="confirm(item.name, item.exists)"
                  >
                    <span v-html="getCustomerName(item.name)"></span>
                    <van-icon
                      class="companyInformation-exist-icon"
                      :name="existIcon"
                    />
                  </div>
                </div>
              </van-list>
              <template #reference>
                <div
                  class="companyname"
                  style="position: relative; height: 60px; width: 100%"
                >
                  <van-field
                    clearable
                    required
                    label="单位名称"
                    placeholder="请输入您的单位名称"
                    type="text"
                    v-model="formData.companyname"
                    :rules="formRules.companyname"
                    @input="onLoad(true)"
                  />
                </div>
              </template>
            </van-popover>
            <van-field
              v-model="formData.phone"
              :rules="formRules.phone"
              type="tel"
              required
              clearable
              label="联系方式"
              :border="false"
              placeholder="请输入您的联系方式"
              @input="onPhoneChange"
            />
            <van-field
              label="验证码"
              class="checkCode"
              required
              type="number"
              :rules="formRules.checkCode"
              v-model="formData.checkCode"
              clearable
              placeholder="请输入验证码"
              center
              :border="false"
            >
              <template #button>
                <van-button
                  size="small"
                  @click="sendCode"
                  :disabled="isSmsSend"
                  class="sendBtnText clickSend"
                  >{{ sendBtnText }}</van-button
                >
              </template>
            </van-field>
            <div class="submitButton">
              <van-button type="info" native-type="submit" size="small"
                >开始体验</van-button
              >
            </div></van-form
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { sendCode, submitForm, queryCompanyName } from "../../api/form";
export default {
  name: "UploadApplicationForm",
  components: {},
  props: {
    consult: String,
  },
  watch: {
  },
  data() {
    return {
      isSmsSend: false, // 发送验证码按钮
      sendBtnText: "获取验证码", // 显示文本
      timer: null, // 计时器对象
      counter: 60, // 倒数60秒
      show: true,
      showPopover: false,
      loading: false,
      finished: true,
      list: [], // 列表
      existIcon: "",
      current: 1, // 当前页数
      size: 500, // 大小
      total: 0, // 总数
      nameIsExist: false,
      formData: {
        companyname: "", // 企业名称
        username: "",
        phone: "",
        checkCode: "", // 验证码
        sourceway: "", // 访问途径
        registerProduct: "轻骑兵", // 注册信息的产品
        interestProduct: "轻骑兵", // 感兴趣产品
        concreteDemand: "", // 具体需求
        appName: "",
        appDesc: "",
      },
      formRules: {
        interestProduct: [{ required: true, message: " ", trigger: "onBlur" }],
        companyname: [{ required: true, message: " ", trigger: "onBlur" }],
        phone: [{ required: true, message: " ", trigger: "onBlur" }],
        checkCode: [{ required: true, message: " ", trigger: "onBlur" }],
      },
    };
  },
  methods: {
    // 发送验证码
    sendCode() {
      const self = this;
      sendCode(self.formData.phone)
        .then((res) => {
          if (
            (res.status === "200" || res.status === 200) &&
            res.data === "发送成功"
          ) {
            self.$message.success("验证码发送成功!");
            // 将按钮禁用，防止再次点击
            self.isSmsSend = true;
            self.countDown();
          } else {
            self.$message.error(res.data);
          }
        })
        .catch((error) => {
          self.$message.error("验证码发送失败!");
        });
    },
    // 关闭定时器
    countDown() {
      const self = this;
      self.timer = setInterval(() => {
        self.sendBtnText = `(${self.counter}秒)后重新发送`;
        self.counter--;
        if (self.counter < 0) {
          // 当计时小于零时，取消该计时器
          clearInterval(self.timer);
          self.reset();
        }
      }, 1000);
    },
    // 当手机号变化时，重置发送按钮
    onPhoneChange() {
      const self = this;
      self.reset();
    },
    // 重置倒计时
    reset() {
      const self = this;
      self.isSmsSend = false;
      self.sendBtnText = "获取验证码";
      if (self.timer) {
        clearInterval(self.timer);
        self.counter = 60;
        self.timer = null;
      }
    },
    // 提交表单
    submit() {
      const self = this;
      let error = false;
      self.$refs.formRules.validate((valid) => {
        error = !valid;
      });
      if (error) {
        return;
      }
      self.formData.concreteDemand =
        "应用名称：" +
        self.formData.appName +
        ",应用简介：" +
        self.formData.appDesc;
      const param = self.formData;
      submitForm(param)
        .then((res) => {
          if (
            (res.data === "注册成功" || res.data === "") &&
            (res.status === "200" || res.status === 200)
          ) {
            self.$message.success("提交成功!");
            self.$emit("openExperienceNowForMall");
            this.closeDialog();
          } else {
            self.$message.error("提交失败!");
          }
        })
        .catch((error) => {
          self.$message.error("提交失败!");
        });
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit("closeExperienceNowForMall");
    },
    // 列表加载
    onLoad(isFresh) {
      const self = this;
      const value = self.formData.companyname;
      self.nameIsExist = false;
      if (value === "") {
        self.showPopover = false;
        self.list = [];
        self.loading = false;
        self.finished = true;
        return;
      } else {
        self.showPopover = true;
        self.loading = true;
        self.finished = false;
      }
      if (isFresh) {
        self.current = 1;
        self.list = [];
      }
      queryCompanyName({ word: value })
        .then((res) => {
          if (res.status === "200" || res.status === 200) {
            self.list = self.list.concat(res.data.result.items || []);
            self.total = res.data.result.total || 0;
            if (self.current * self.size >= self.total) {
              self.finished = true;
            }
            self.current += 1;
            self.loading = false;
          } else {
            self.finished = true;
            self.loading = false;
          }
        })
        .catch((err) => {
          self.finished = true;
          self.loading = false;
        });
    },
    // 搜索关键字显示特殊颜色
    getCustomerName(name) {
      const self = this;
      const index = name.indexOf(self.formData.checkCode);
      if (index !== -1) {
        let prefix = name.substring(0, index);
        let key = self.formData.checkCode;
        let end = name.substring(index + key.length, name.length);
        return `${prefix}<span style="color: #008AFF;">${key}</span>${end}`;
      } else {
        return name;
      }
    },
    // 点击选择选项
    confirm(name, exists) {
      const self = this;
      self.formData.companyname = name;
      self.showPopover = false;
      self.list = [];
      self.finished = true;
      self.loading = false;
      self.nameIsExist = exists;
    },
    // 获取感兴趣产品
    getConsult() {
      this.formData.interestProduct = this.consult;
    },
  },
  mounted() {
    this.getConsult();
  },
};
</script>
<style scoped>
.popup {
  background: url("../../assets/img/MallPhonePage/experienceNow.png") no-repeat;
  background-size: cover;
  height: 100%;
}
.title {
  padding: 30px 0 10px 0;
  display: flex;
  justify-content: center;
  font-size: 0.4rem;
  font-weight: 500;
  color: #018dff;
}
.formData {
  padding: 5px 30px;
}
.submitButton {
  display: flex;
  justify-content: center;
  margin: 35px 0px 35px 0px;
}
.submitButton .van-button__text {
  font-size: 0.29rem;
}
/deep/ .van-cell {
  display: block;
  padding: 0;
  background: none;
  margin-bottom: 5px;
  align-items: center;
}
/deep/ .van-cell__value {
  line-height: 40px;
}
/deep/ .van-cell__value.van-field__value {
  background: #fff;
  line-height: 30px;
  border: 0.8px solid #d5d8dd;
  border-radius: 2px;
}
/deep/ .van-field__control {
  padding: 0 5px;
  line-height: 40px !important;
  font-size: 13px;
}
/deep/ .van-cell__title {
  font-size: 0.25rem;
  text-align: left;
  line-height: 30px;
  margin-left: 10px;
}
/deep/ .van-field__label {
  width: 100%;
}
/deep/ .van-cell--required::before {
  line-height: 35px;
  left: 0;
}
/deep/ .van-button {
  width: 100%;
  height: 35px;
}

.companyInformation.van-popover__wrapper {
  width: 100%;
  display: flex;
  margin-bottom: 17px;
}
.companyInformation .van-popover .list-item {
  width: 100%;
  line-height: 33px;
  padding: 0 16px;
  position: relative;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  letter-spacing: 0;
  text-align: left;
  background: #fcf3e2;
}
.companyInformation .van-popover .list-item::after {
  width: calc(100% - 32px);
  height: 1px;
  background: #eeeeee;
  bottom: 0;
  left: 16px;
  position: absolute;
}
.companyInformation-exist-icon {
  position: absolute;
  right: 16px;
  top: 9px;
  font-size: 16px;
}
/deep/ .companyInformation .van-popover {
  /* top: 315px !important; */
  width: 100%;
  left: 0 !important;
  /* height: calc(100% - 200px); */
  height: 180px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  background: #fcf3e2;
  box-shadow: 5px 5px 5px #eeeeee;
}
/deep/ .companyInformation .van-popover--light .van-popover__content {
  box-shadow: none;
}
/deep/ .comp .companyInformation .van-cell.van-field {
  align-items: center;
}
/deep/ .companyInformation .van-field__control {
  color: #323233;
}

/deep/ .appDesc {
  align-items: normal;
}
.sendBtnText {
  font-size: 13px;
  color: cornflowerblue;
  border: none;
}
/deep/ .clickSend:focus {
  background: rgb(238, 247, 254);
}
</style>



// WEBPACK FOOTER //
// src/components/include/ExperienceNowForMall.vue